package com.exura.features.userprofile.domain.usecase

import com.exura.features.newauth.domain.manager.AuthManager
import com.exura.features.newauth.domain.model.AuthState
import com.exura.features.newauth.domain.model.UserRole
import com.exura.features.userprofile.domain.model.DoctorProfile
import com.exura.features.userprofile.domain.model.OrganizationProfile
import com.exura.features.userprofile.domain.model.ProviderProfile
import com.exura.features.userprofile.domain.repository.ProviderProfileRepository
import kotlinx.coroutines.flow.filterIsInstance
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.mapNotNull

class GetProviderProfileUseCase(
    private val profileRepository: ProviderProfileRepository,
    private val authManager: AuthManager,
) {
    suspend operator fun invoke() : Result<ProviderProfile?> = runCatching{

        val profile = profileRepository.getSettings("profile").getOrNull()

        if (profile == null) {
            val user = authManager.state
                .filterIsInstance<AuthState.Authenticated>()
                .mapNotNull { it.user }
                .first()
            if (user.userRole == UserRole.DOCTOR) {
                DoctorProfile(
                    email = user.email,
                    fullName = null,
                    specialization = null,
                )
            } else {
                OrganizationProfile(
                    email = user.email,
                    name = null,
                    field = null,
                    patientsContactNumber = null,
                )
            }
        } else {
            profile
        }
    }
}
